import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ArrowLeft16 from '@wix/da-ds/pkg/Icons/16x16/ArrowLeft';
import { FieldFormPopupProps } from './types';

import s from './FieldFormPopup.scss';

const FieldFormPopup: React.FC<FieldFormPopupProps> = ({
  heading,
  subheading,
  contentClassName,
  isOpen,
  toggleModal,
  onSave,
  children,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <Modal
      isOpen={isOpen}
      heading={heading}
      subheading={subheading}
      headerClassName={s['modal-header']}
      contentClassName={cn(s['modal-content'], contentClassName)}
      headerLeft={
        isMobile ? (
          <IconButton
            size="medium"
            icon={ArrowLeft16}
            onClick={toggleModal}
            aria-label={t('common.close')}
          />
        ) : undefined
      }
      hasCloseButton={!isMobile}
      showHeaderBorder
      showFooterBorder
      withScrollableContentWrapper={false}
      onRequestClose={toggleModal}
      footerRight={[
        <TextButton
          key="cancel"
          variant="main"
          size="large"
          onClick={toggleModal}
        >
          {t('deviationSubmit.form.fieldPopup.cta.cancel')}
        </TextButton>,
        <SolidButton
          key="submit"
          variant="approval-green"
          size="large"
          onClick={onSave}
        >
          {t('deviationSubmit.form.fieldPopup.cta.save')}
        </SolidButton>,
      ]}
    >
      {children}
    </Modal>
  );
};
FieldFormPopup.displayName = 'FieldFormPopup';

export default FieldFormPopup;
